export default __webpack_public_path__ + "static/media/EduclerkBrochure.743dca08.pdf";